// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const riderApi = baseApi.injectEndpoints({
  // reducerPath: "riderApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllRider: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `riders?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getRiderDetail: builder.query({
      query: ({ slug }) => {
        return {
          url: `riders/${slug}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    approveRider: builder.mutation({
      query: (slug) => {
        return {
          url: `approve-rider/${slug}`,
          method: "POST",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    UnApproveRider: builder.mutation({
      query: (slug) => {
        return {
          url: `unapprove-rider/${slug}`,
          method: "POST",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllRiderQuery,
  useGetRiderDetailQuery,
  useApproveRiderMutation,
  useUnApproveRiderMutation,
} = riderApi;
